import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPowerPivotState } from '../interfaces/IPowerPivotState';

export const initialState = {
  showSharePointModalPowerPivot: true,
  showPowerPivotNotSupportedModal: false,
} as IPowerPivotState;

const powerPivotSlice = createSlice({
  name: 'powerPivot',
  initialState,
  reducers: {
    resetPowerPivotFlags: (state) => {
      return {
        ...state,
        showSharePointModalPowerPivot: true,
        showPowerPivotNotSupportedModal: false,
      };
    },
    setShowSharePointModalPowerPivot: (
      state,
      action: PayloadAction<boolean>
    ) => {
      return {
        ...state,
        showSharePointModalPowerPivot: action.payload,
      };
    },
    setShowPowerPivotNotSupportedModal: (
      state,
      action: PayloadAction<boolean>
    ) => {
      return {
        ...state,
        showPowerPivotNotSupportedModal: action.payload,
      };
    },
  },
});

// Actions
export const {
  resetPowerPivotFlags,
  setShowSharePointModalPowerPivot,
  setShowPowerPivotNotSupportedModal,
} = powerPivotSlice.actions;

export default powerPivotSlice.reducer;
